import { Injectable } from '@angular/core';
declare var webkitSpeechRecognition: any;

@Injectable({
  providedIn: 'root',
})
export class VoiceRecognitionAssessmentService {
  recognition = new webkitSpeechRecognition();
  isStoppedSpeechRecog = false;
  public Assessment = '';
  tempWords;
  private instantStarted = false;

  constructor() {}

  init() {
    this.recognition.interimResults = true;
    this.recognition.lang = 'en-US';

    this.recognition.addEventListener('result', (e) => {
      const transcript = Array.from(e.results)
        .map((result) => result[0])
        .map((result) => result.transcript)
        .join('');
      this.tempWords = transcript;
      // console.log(transcript);
    });
  }

  startAssessment() {
    if (!this.instantStarted) {
      this.isStoppedSpeechRecog = false;
      this.recognition.start();
      this.instantStarted = true;
      console.log('Speech recognition started');
      this.recognition.addEventListener('end', (condition) => {
        if (this.isStoppedSpeechRecog) {
          this.recognition.stop();
          // console.log('End speech recognition');
        } else {
          this.wordConcatAssessment();
          this.recognition.start();
        }
      });
    }
  }
  stopAssessment() {
    if (this.instantStarted) {
      this.isStoppedSpeechRecog = true;
      this.wordConcatAssessment();
      this.recognition.stop();
      this.instantStarted = false;
      // console.log('End speech recognition');
    }
  }

  wordConcatAssessment() {
    this.Assessment = this.Assessment + ' ' + this.tempWords + '.';
    this.tempWords = '';
  }
}
